import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep9 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/') {
      this.props.history.push('/');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 9});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 8});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          That was short walkthrough the AsyncCoin
        </h2>
        <p>
          Try it freely, if you have any suggestion, or have spotted any bugs, or would like to talk about anything
          blockchain related - talk with us at <code>coin@asynclabs.co</code>
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Finish</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep9);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep9.js